import { styled } from '@mui/material';
import { ReactQueryDevtools as Devtools } from '@tanstack/react-query-devtools';
import env from '@/util/env';
import { useQueryParam } from '@/util/useQuery';
import { useChatbot } from '../chatbot/useChatbot';

const FixedContainer = styled('div')(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(4),
  right: theme.spacing(12),
  padding: '1px',
  zIndex: 1200,
}));

export const ReactQueryDevtools = () => {
  const [debug] = useQueryParam('debug');
  if (debug !== 'true') {
    return null;
  }

  if (!env.CHATBOT_ENABLED) {
    return <Devtools initialIsOpen={false} buttonPosition="bottom-right" />;
  }

  return <ChatbotAwareReactQueryDevtools />;
};

const ChatbotAwareReactQueryDevtools = () => {
  const { isAvailable: viewChatbot, isOpen: chatbotOpen } = useChatbot();

  if (viewChatbot && !chatbotOpen) {
    return (
      <FixedContainer>
        <Devtools initialIsOpen={false} buttonPosition="relative" />
      </FixedContainer>
    );
  }

  if (chatbotOpen) {
    return <Devtools initialIsOpen={false} buttonPosition="bottom-left" />;
  }

  return <Devtools initialIsOpen={false} buttonPosition="bottom-right" />;
};
